'use client'

import dynamic from 'next/dynamic'

const CityLocationMap = dynamic(() => import('@/app/components/CityLocationMap'), {
  ssr: false,
  loading: () => (
    <div className="flex items-center justify-center rounded-lg border border-[var(--border)] bg-[var(--surface-1)]" style={{ minHeight: '280px' }}>
      <p className="text-sm text-[var(--text-3)]">Loading map...</p>
    </div>
  ),
})

export default function CityMapClient({
  lat,
  lng,
  cityName,
  className,
}: {
  lat: number
  lng: number
  cityName: string
  className?: string
}) {
  return <CityLocationMap lat={lat} lng={lng} cityName={cityName} className={className} />
}
